import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import KpiTable from '../../../commons/KpiTable';
import { isNaN, isNil } from 'lodash';

const ContentCourseSpeechRateTable = (props) => (
  <KpiTable
    title="Speech recognition difficulty"
    description="The number represents the average record button usage per item execution. The exercises which represent this number are: Presentation, Video Short, Pronunciation, Speech Practice, Unscramble Speech Recognition, Gap Fill, Single Choice Game, Phoneme, Vocabulary and Vocabulary Kids."
    loading={props.loading}
    values={props.values}
    currentHigherIsBetter={false}
    onSelect={props.onSelect}
    formatter={props.formatter}
    nameColumnPath={props.nameColumnPath}
    nameColumnRender={props.nameColumnRender}
    additionalColumns={[
      {
        label: 'Executions',
        path: 'totalExecutions',
        sort: true,
        render: (value) => {
          if (isNil(value) || isNaN(value)) {
            return 'N/A';
          }
          return numeral(value).format('0,0').replace(',', '.');
        },
      },
    ]}
    feedbackColorRender={props.feedbackColorRender}
  />
);

ContentCourseSpeechRateTable.propTypes = {
  onSelect: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  values: PropTypes.array.isRequired,
  nameColumnPath: PropTypes.string,
  formatter: PropTypes.func.isRequired,
  feedbackColorRender: PropTypes.func.isRequired,
};

ContentCourseSpeechRateTable.defaultProps = {
  nameColumnPath: 'order',
};

export default ContentCourseSpeechRateTable;
